import type { Deck, UserSettings } from '../types';
import { getDefaultLanguagePair } from '../config/languages';

export const defaultDecks: Deck[] = [
  {
    id: 'deck-general',
    name: 'General',
    emoji: '📚',
    languagePair: getDefaultLanguagePair().code,
    cardCount: 0,
    isDefault: true,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'deck-food',
    name: 'Food & Drink',
    emoji: '🍽️',
    languagePair: getDefaultLanguagePair().code,
    cardCount: 0,
    isDefault: false,
    createdAt: new Date().toISOString(),
  },
  {
    id: 'deck-travel',
    name: 'Travel',
    emoji: '✈️',
    languagePair: getDefaultLanguagePair().code,
    cardCount: 0,
    isDefault: false,
    createdAt: new Date().toISOString(),
  },
];

export const defaultSettings: UserSettings = {
  theme: 'system',
  dailyNewCardLimit: 20,
  ttsEnabled: true,
  ttsSpeed: 1,
  autoPlayTts: true,
  currentLanguagePair: getDefaultLanguagePair().code,
  onboardingCompleted: false,
  streak: 0,
  lastReviewDate: null,
  reviewMode: 'mixed',
  isPro: false,
  uiLocale: 'en',
  immersionMode: false,
  milestonesSeen: [],
  cefrLevel: null,
  streakFreezeAvailable: true,
  username: null,
  autoEasyThresholdMs: 1500,
  cardCreationPreset: 'standard',
  imagePickerMode: 'fullscreen',
};
